import {f7} from "framework7-vue";
import {FirebaseService} from "@/services/firebase/FirebaseService";
import LogService from "@/services/log-service/LogService";
import {FirebaseEvents} from "@/services/firebase/analytics/FirebaseEvents";
import FirebaseEventBuilder from "@/services/firebase/analytics/FirebaseEventBuilder";
import {AccountError, UserError} from "@enums/ServerErrorCodes";
import ServiceAccount from "@/services/v2/data/service-account/ServiceAccount";
import { tolgee } from "@/langs/tolgee";

export default class ErrorsService {
    private static _instance: ErrorsService | null = null;

    public static of() {
        if (this._instance === null) this._instance = new ErrorsService();
        return this._instance;
    }

    public async handle(e: any, callback?: (() => Promise<void> | void) | null) {
        if (e.code && tolgee.t(`errors.${e.code}`)) {
            switch (e.code) {
                case AccountError.AgentNotFound:
                    FirebaseService.of().analyticsEvent(
                        FirebaseEvents.PAYMENT_ERROR_NO_AGENTS,
                        FirebaseEventBuilder.of().build()
                    );

                    if (callback) {
                        await callback();
                    } else {
                        f7.dialog.alert(
                          tolgee.t(`errors.${e.code}`),
                          tolgee.t('g.errors.alert.default-title')
                        );
                    }

                    break;
                case AccountError.AgentsUnavailableForAmount:
                    LogService.of().log("ErrorService@handle", AccountError.AgentsUnavailableForAmount);
                    FirebaseService.of().analyticsEvent(
                        FirebaseEvents.PAYMENT_ERROR_WRONG_RANGE,
                        FirebaseEventBuilder.of().build()
                    );
                    FirebaseService.of().emptyRangeMetricSuccess.reset();
                    FirebaseService.of().wrongRangeMetricSuccess.startObserve();

                    if (callback) {
                        await callback();
                    } else {
                        f7.dialog.alert(
                          tolgee.t(`errors.${e.code}`),
                          tolgee.t('g.errors.alert.default-title')
                        );
                    }

                    break;
                case AccountError.AgentsUnavailableForRangeAmount:
                    LogService.of().log("ErrorService@handle", AccountError.AgentsUnavailableForRangeAmount);
                    FirebaseService.of().analyticsEvent(
                        FirebaseEvents.PAYMENT_ERROR_EMPTY_RANGE,
                        FirebaseEventBuilder.of().build()
                    );
                    FirebaseService.of().wrongRangeMetricSuccess.reset();
                    FirebaseService.of().emptyRangeMetricSuccess.startObserve();

                    if (callback) {
                        await callback();
                    } else {
                        f7.dialog.alert(
                          tolgee.t(`errors.${e.code}`),
                          tolgee.t('g.errors.alert.default-title')
                        );
                    }

                    break;
                case UserError.UserTemporarilyBlocked:
                    await ServiceAccount.of().fetchAccount();

                    const allowTypes = ['dev-integration', 'integration'];
                    if (allowTypes.includes(import.meta.env.VITE_APP_TYPE)) {
                        const el: HTMLDivElement | null = document.querySelector('.no-agents-sheet');

                        if (el) {
                            const sheet = f7.sheet.create({ el });
                            sheet.open();
                        }
                    } else {
                        setTimeout(() => {
                            const el: HTMLDivElement | null = document.querySelector('.ban-sheet');

                            if (el) {
                                const sheet = f7.sheet.create({ el });
                                sheet.open();
                            }
                        }, 314);
                    }
                    break;
                default:
                    f7.dialog.alert(tolgee.t(`errors.${e.code}`), tolgee.t('g.errors.alert.default-title'));
            }
        } else {
            f7.dialog.alert(tolgee.t('g.errors.alert.default-text'), tolgee.t('g.errors.alert.default-title'));
        }
    }
}
